import { SendUpdates, SeriesScope } from '@common/interfaces/calendar'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'calendar'

export const [
  LIST_CALENDAR_EVENTS_REQUEST,
  LIST_CALENDAR_EVENTS_SUCCESS,
  LIST_CALENDAR_EVENTS_FAILURE,
] = createRequestTypes(prefix, 'LIST_CALENDAR_EVENTS')

export const listCalendarEvents = createAction((params: object = {}) => ({
  type: [LIST_CALENDAR_EVENTS_REQUEST, LIST_CALENDAR_EVENTS_SUCCESS, LIST_CALENDAR_EVENTS_FAILURE],
  promise: (api: IApi) => api.calendar.listEvents(params),
  params,
}))

export interface ICreateCalendarEventParams {
  summary: string
  /** ISO datetimes with offset. */
  start: string
  end: string
  attendees?: string[]
  description?: string
  location?: string
  addZoom?: boolean
}

export const [
  CREATE_CALENDAR_EVENT_REQUEST,
  CREATE_CALENDAR_EVENT_SUCCESS,
  CREATE_CALENDAR_EVENT_FAILURE,
] = createRequestTypes(prefix, 'CREATE_CALENDAR_EVENT')

export const createCalendarEvent = createAction((params: ICreateCalendarEventParams) => ({
  type: [
    CREATE_CALENDAR_EVENT_REQUEST,
    CREATE_CALENDAR_EVENT_SUCCESS,
    CREATE_CALENDAR_EVENT_FAILURE,
  ],
  promise: (api: IApi) => api.calendar.createEvent(params),
  params,
}))

/** Only the fields being changed; attendees, when present, replace the whole list. */
export interface IUpdateCalendarEventPatch {
  summary?: string
  start?: string
  end?: string
  attendees?: string[]
  description?: string
}

export interface IUpdateCalendarEventOptions {
  scope?: SeriesScope
  /** Everyone by default. */
  sendUpdates?: SendUpdates
}

export interface IUpdateCalendarEventParams extends IUpdateCalendarEventOptions {
  eventId: string
  patch: IUpdateCalendarEventPatch
}

export const [
  UPDATE_CALENDAR_EVENT_REQUEST,
  UPDATE_CALENDAR_EVENT_SUCCESS,
  UPDATE_CALENDAR_EVENT_FAILURE,
] = createRequestTypes(prefix, 'UPDATE_CALENDAR_EVENT')

export const updateCalendarEvent = createAction(
  (
    eventId: string,
    patch: IUpdateCalendarEventPatch,
    options: IUpdateCalendarEventOptions = {},
  ) => ({
    type: [
      UPDATE_CALENDAR_EVENT_REQUEST,
      UPDATE_CALENDAR_EVENT_SUCCESS,
      UPDATE_CALENDAR_EVENT_FAILURE,
    ],
    promise: (api: IApi) => api.calendar.updateEvent(eventId, patch, options),
    params: { eventId, patch, ...options } satisfies IUpdateCalendarEventParams,
  }),
)

export const [
  DELETE_CALENDAR_EVENT_REQUEST,
  DELETE_CALENDAR_EVENT_SUCCESS,
  DELETE_CALENDAR_EVENT_FAILURE,
] = createRequestTypes(prefix, 'DELETE_CALENDAR_EVENT')

export const deleteCalendarEvent = createAction((eventId: string) => ({
  type: [
    DELETE_CALENDAR_EVENT_REQUEST,
    DELETE_CALENDAR_EVENT_SUCCESS,
    DELETE_CALENDAR_EVENT_FAILURE,
  ],
  promise: (api: IApi) => api.calendar.deleteEvent(eventId),
  params: { eventId },
}))
